export function getDate() {
  return new Date()
    .toISOString()
    .replace('T', ' ')
    .replace(/\.(\d{3})Z$/, (_, ms) => `,${ms}`)
}
